import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const Support = () => import('./views/Index.vue');

export default [
  {
    path: '/support',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'Support',
        component: Support,
        meta: { title: i18n.global.t('settings.support') },
      },
    ],
  },
];
